import React, { useEffect, useState } from "react";
import { Button, TextField, Typography, Stack, Checkbox, InputAdornment, IconButton } from "@mui/material";
import { useLoginPageTitle } from "../../util/usePageTitle";
import { Action } from "../../util/func";
import { Icons } from "../../image/Icons";
import { getHexCode } from "../../util/Color";
import { Link } from "react-router-dom";
import { GetCookieValue, SetCookie } from "../../util/CookieManager";

export default function LoginPage({ login }: { login: Action<{ username: string; password: string }> }) {
  useLoginPageTitle();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    login({ username, password });
  };

  return (
    <Stack width="100%" alignItems="center">
      <Stack p="32px" alignItems={"center"} maxWidth={800} width="100%" gap="21.6px">
        <Stack alignItems="center" justifyItems="center" gap="27.2px">
          <img width={100} height={100} src={Icons.OkumuraIcon} />
          <Typography fontSize={32} fontWeight="bold" lineHeight={1}>ログイン</Typography>
        </Stack>
        <Stack width={"70%"} gap={2} component="form" onSubmit={handleSubmit} sx={{ 
          mt: 3, 
          py: 7, 
          px: 4, 
          "borderRadius": "10px", 
          boxShadow: 3,
          "background": (theme) => `
            linear-gradient(
              to bottom,
              ${getHexCode("SubBlue")} 0 8px,
              ${theme.palette.background.paper} 8px 100%
            )
          `,
        }}>
          <Stack margin={0}>
            <Typography fontSize={20} fontWeight={"bold"}>ID</Typography>
            <TextField required fullWidth autoComplete="username" id="username" placeholder="ID を入力してください" name="username" autoFocus value={username} onChange={handleUsernameChange} />
          </Stack>
          <Stack margin={0}>
            <Typography fontSize={20} fontWeight={"bold"}>パスワード</Typography>
            <TextField 
              required
              fullWidth
              autoComplete="current-password"
              name="password" 
              placeholder="パスワード を入力してください" 
              type={ showPassword ? "text" : "password" } 
              id="password" 
              value={password} 
              onChange={handlePasswordChange} 
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                        onClick={() => setShowPassword((prev) => !prev)}
                      >
                        <img width={35} src={showPassword ? Icons.PassActive : Icons.PassInactive} />
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Stack>
          <Stack sx={{ mt: 8 }} gap={1}>
            <Button type="submit" fullWidth variant="contained" sx={{ py: 3, "borderRadius": "10px" }}>
              <Typography fontSize={22} fontWeight={"bold"}>ログイン</Typography>
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
